import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { cn } from '@shared/utils/utils';

export interface SelectOption {
  value: string;
  label: string;
}

@Component({
  selector: 'app-select',
  template: `
    <select
      [class]="selectClasses()"
      [value]="value()"
      (change)="onChange($event)"
    >
      @if (placeholder()) {
        <option value="" [disabled]="true" [selected]="!value()">{{ placeholder() }}</option>
      }
      @for (opt of options(); track opt.value) {
        <option [value]="opt.value" [selected]="opt.value === value()">{{ opt.label }}</option>
      }
    </select>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectComponent {
  options = input<SelectOption[]>([]);
  placeholder = input('');
  value = model<string>('');
  disabled = input(false);

  protected readonly selectClasses = computed(() =>
    cn(
      'h-9 w-full rounded-md border border-border bg-white px-3 py-1 text-sm',
      'focus:outline-none focus:ring-2 focus:ring-primary',
      'disabled:opacity-50 disabled:pointer-events-none',
      this.disabled() ? 'opacity-50 pointer-events-none' : ''
    )
  );

  protected onChange(event: Event): void {
    this.value.set((event.target as HTMLSelectElement).value);
  }
}
